/**
 * Returns all props that start with `data-`.
 * @param props - The icon component's props.
 * @returns All props that start with `data-`.
 */
export const getDataProps = props => {
  return Object.fromEntries(Object.entries(props).filter(([key]) => key.startsWith('data-')));
};